/** Баланс продуктовых токенов (1 токен ≈ 1 ₽). */
export function resolveTokenBalance(userLike) {
  if (!userLike) return 0
  const raw =
    userLike.token_balance ??
    userLike.analysis_balance ??
    userLike.balance ??
    0
  const n = Number(raw)
  return Number.isFinite(n) ? n : 0
}
